import styled from '@emotion/styled';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { QrCodeScanner } from '@mui/icons-material';
import { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type MobileMenuProps = {
  menuConfig: {
    text: string;
    icon: React.ReactNode;
    path: string;
  }[];
};

export const MobileMenu = memo(({ menuConfig }: MobileMenuProps) => {
  const navigate = useNavigate();

  const [route, setRoute] = useState(0);

  return (
    <MenuContainer>
      <Paper
        elevation={3}
        sx={{
          width: '100vw',
          paddingBottom: '20px',
        }}
      >
        <BottomNavigation
          sx={{ width: '100vw' }}
          showLabels
          value={route}
          onChange={(_event, newValue) => {
            setRoute(newValue);
          }}
        >
          {menuConfig.map((config) => (
            <BottomNavigationAction
              onClick={() => navigate(config.path)}
              key={config.text}
              label={config.text}
              icon={config.icon}
            />
          ))}
          <BottomNavigationAction
            onClick={() => navigate('/scanner')}
            key="scanner"
            label="Scanner"
            icon={<QrCodeScanner />}
          />
        </BottomNavigation>
      </Paper>
    </MenuContainer>
  );
});

const MenuContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  z-index: 2;
  left: 0;
  right: 0;
  padding-bottom: env(safe-area-inset-bottom);
  @media (min-width: 769px) {
    display: none;
  }
`;
